<template>
  <div class="my_cropper2">
    <!-- 多图裁剪上传组件 -->
    <!-- 上传框和预览只有正方形和横着的长方形2种 -->
    <el-upload
      action
      :class="uploadParams.shape"
      list-type="picture-card"
      :multiple="true"
      :file-list="uploadParams.fileList"
      :on-preview="handlePictureCardPreview"
      :on-remove="handleAbstractRemove"
      :on-progress="test"
      :on-success="success"
      :limit="uploadParams.limit || 5"
      :auto-upload="false"
      :on-exceed="handleExplainExceed"
      accept="image/jpeg, image/jpg, image/png, image/gif"
      :on-change="changeUpload"
    >
      <i class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
    <!-- 弹窗 -->
    <el-dialog
      title="图片剪裁（滚轮放大缩小）"
      :visible.sync="dialogVisible"
      width="800px"
      :before-close="close"
    >
      <div class="cropper-content">
        <div class="cropper-content-l">
          <div class="cropper" style="text-align:center">
            <vueCropper
              ref="cropper2"
              :img="option.img"
              :outputSize="option.size"
              :outputType="option.outputType"
              :info="true"
              :full="option.full"
              :canMove="option.canMove"
              :canMoveBox="option.canMoveBox"
              :original="option.original"
              :autoCrop="option.autoCrop"
              :fixed="option.fixed"
              :fixedNumber="uploadParams.fixedNumber"
              :centerBox="option.centerBox"
              :infoTrue="option.infoTrue"
              :fixedBox="option.fixedBox"
              @realTime="realTime"
            ></vueCropper>
          </div>
        </div>
        <div class="cropper-content-r">
          <h5>预览</h5>
          <!-- 裁剪预览 -->
          <div
            class="show-preview"
            :style="{'width': previews.w + 'px', 'height': previews.h + 'px',  'overflow': 'hidden',}"
          >
            <div :style="previews.div">
              <img :src="option.img" :style="previews.img" style="width:100%;" />
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="finish" :loading="loading">确认</el-button>
      </div>
    </el-dialog>
    <!--图片查看弹窗-->
    <el-dialog :visible.sync="dialogImageVisible" width="650px">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api/api";
export default {
  props: {
    params: {
      type: Object
    },
    uploadParams: {
      type: Object
    }
  },
  data() {
    return {
      img: this.params[this.uploadParams["filePathfield"]] || "",
      fileList: [],
      dialogVisible: false,
      // 裁剪组件的基础配置option
      dialogImageVisible: false,
      dialogImageUrl: "",
      option: {
        img: "", // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: "png", // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        // autoCropWidth: 240, // 默认生成截图框宽度
        // autoCropHeight: 180, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        full: false, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
      loading: false,
      fileInfo: null,
      previews: "" //预览
      //   previewStyle1: null
    };
  },
  methods: {
    close() {
      this.dialogVisible = false;
    },
    test(event, file, fileList){
      console.log(event, file, fileList)
    },
    success(response, file, fileList){
      debugger
      console.log(response, file, fileList)
    },
    // 限制图片大小
    async changeUpload(file, fileList) {
      console.log(1)
      let size = this.uploadParams.size; //文件大小限制
      const isLt2M = file.size / 1024 / 1024 < size;
      const _text = size < 1 ? size * 1024 + "KB" : size + "MB";
      if (!isLt2M) {
        this.$message.error(`上传文件大小不能超过 ${_text}!`);
      }
      //   base64转换
      let src = await this.common.readFile(file.raw);
      this.fileInfo = file.raw;
      // console.log(file.raw);
      // 上传成功后将图片地址赋值给裁剪框显示图片
      this.option = Object.assign({}, this.option, {
        img: src
      });
      this.dialogVisible = true;
    },
    // 点击裁剪
    finish() {
      let self = this;
      // 获取截图的base64 数据
      // this.$refs.cropper2.getCropData(data => {
      //   // do something
      //   self.params[self.uploadParams["filePathfield"]] = data;
      // });
      // 获取截图的blob数据
      this.$refs.cropper2.getCropBlob(data => {
        // 上传服务器
        self.uploadFile(data);
      });
    },
    // 上传文件到服务器
    uploadFile(data) {
      var file = new File([data], this.fileInfo.name, {
        type: this.fileInfo.type
      });
      this.api.uploadFile2({
        file,
        catalog: "CatalogUserHead",
        loginKey: sessionStorage.getItem("loginKey")
      }).then(res => {
        let obj = {
          fileId: res.obj.fileId,
          filePath: res.obj.filePath,
          ziduan: this.uploadParams.ziduan,
          filePathfield: this.uploadParams.filePathfield
        };
        this.uploadParams.fileList.push({
          id: res.obj.fileId,
          url: res.obj.filePath
        });
        this.$emit("uploadObj", obj);
        this.dialogVisible = false;
      });
    },
    // 预览
    realTime(data) {
      // console.log(data);
      // console.log(data.w, data.h);
      var previews = data;
      var h = 0.5;
      var w = 0.2;

      //   this.previewStyle1 = {
      //     width: previews.w + "px",
      //     height: previews.h + "px",
      //     overflow: "hidden",
      //     margin: "0",
      //     zoom: h
      //   };

      this.previews = data;
    },
    /**
     * 查看图片
     */
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogImageVisible = true;
    },
    /**
     * 删除图片处理-详情图
     * file 删除的文件
     * fileList 删除后的文件列表
     */
    handleAbstractRemove(file, fileList) {
      let list = this.uploadParams.fileList;
      list.forEach((item, idx, arr) => {
        if (item.id === file.id || item.uid === file.uid) {
          list.splice(idx, 1);
        }
      });
      if(file.id){
        let obj = {
          fileId: file.id,
          ziduan: this.uploadParams.ziduan,
          filePathfield: this.uploadParams.filePathfield
        };
        this.$emit('remove', obj)
      }
    },
    /**
     * 最多只能上传5张详情图
     */
    handleExplainExceed() {
      let num = this.uploadParams.limit || 5;
      this.$message({
        message: `最多只能上传${num}张图片`,
        type: "error"
      });
    }
  }
};
</script>

<style lang="scss">
.my_cropper2 {
  .rectangle {
    .el-upload,
    .el-upload-list__item {
      width: 120px;
      height: 90px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  .el-upload.el-upload--picture-card{
    display: flex;
    align-items: center;
  }
  .square,
  .rectangle,
  .el-upload-list {
    display: flex;
  }
  .square {
    .el-upload,
    .el-upload-list__item {
      width: 80px;
      height: 80px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  .cropper-content {
    display: flex;
    justify-content: space-between;
    .cropper {
      width: 400px;
      height: 300px;
    }
    .cropper-content-r {
      & > h5 {
        font-size: 16px;
        text-align: center;
        font-weight: 600;
        height: 30px;
        line-height: 30px;
      }
    }
  }
}
</style>
